module.exports = __webpack_public_path__ + "static2023-4-17/img/comment-red-packet-bg.d46487ee.png";